export const PeriodsEnum = {
  OneWeek: 1,
  TwoWeeks: 2,
  OneMonth: 3,
  SixMonths: 4,
  Year: 5,
};

export const StatsEnum = {
  Displays: 'displays',
  Views: 'views',
  PhoneViews: 'phone_views',
  Favorites: 'favorites',
  AddToCart: 'add_to_cart',
};

export const formatStatValue = (value) => {
  const num = Number(value);
  if (isNaN(num)) return value; // guard for invalid inputs
  if (num >= 1000) return num.toLocaleString(); // adds commas automatically
  return num;
};

export const periods = [
  { label: 'NM_FilterOneWeek', value: PeriodsEnum.OneWeek },
  { label: 'NM_FilterTwoWeek', value: PeriodsEnum.TwoWeeks },
  { label: 'NM_FilterOneMonth', value: PeriodsEnum.OneMonth },
  { label: 'NM_FilterSixMonth', value: PeriodsEnum.SixMonths },
  { label: 'NM_FilterOneYear', value: PeriodsEnum.Year },
];

export const PeriodLabelsMap = {
  [PeriodsEnum.OneWeek]: 'NM_StatsLabelOneWeek',
  [PeriodsEnum.TwoWeeks]: 'NM_StatsLabelTwoWeek',
  [PeriodsEnum.OneMonth]: 'NM_StatsLabelOneMonth',
  [PeriodsEnum.SixMonths]: 'NM_StatsLabelSixMonths',
  [PeriodsEnum.Year]: 'NM_StatsLabelOneYear',
};

export const calculateYAxisConfig = (maxValue) => {
  if (maxValue <= 25) return { domain: [0, 25], ticks: [0, 5, 10, 15, 20, 25] };

  // We need 5 intervals (6 ticks including 0)
  const intervals = 5;

  // Calculate the interval size, rounding up
  const rawInterval = Math.ceil(maxValue / intervals);

  // Round interval to nearest 5 or 10
  let interval;
  if (rawInterval <= 5) {
    interval = 5;
  } else if (rawInterval <= 10) {
    interval = 10;
  } else {
    // Round up to nearest multiple of 5
    interval = Math.ceil(rawInterval / 5) * 5;
  }

  const maxTick = interval * intervals;
  const ticks = Array.from({ length: 6 }, (_, i) => i * interval);

  return { domain: [0, maxTick], ticks };
};